import { render, staticRenderFns } from "./TableOfficeVisit.vue?vue&type=template&id=1197d9b5"
import script from "./TableOfficeVisit.vue?vue&type=script&lang=js"
export * from "./TableOfficeVisit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports